import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeSelectProjectPanel } from '@App/store/actions/project';
import MyProjects from '@App/api/query/MyProjects.graphql';
import Query from '@App/components/api/Query';
import SelectProjectPanel from '@App/components/page/project/SelectProjectPanel';
import ForbiddenPanel from '@App/components/authentication/ForbiddenPanel';
import I18n from 'i18n-js';

/**
 * GraphQL-wrapped SelectProjectPanel
 *
 * @see @App/components/container/BackdropContainer to close panel when clicking outside
 */
function SelectProjectPanelContainer({
    onClose,
    authenticated,
    trackReference,
    versionReference,
    searchResultsPosition,
}) {
    if(trackReference === null || versionReference === null) {
        return null;
    }

    if (!authenticated) {
        return <ForbiddenPanel
            id="select-project"
            title={I18n.t('panel.project.add-track.select')}
            translationKeyPrefix="panel.project-forbidden"
            versionReference={versionReference}
            authenticated={authenticated}
            onClose={onClose}
        />;
    }

    return <Query
        component={SelectProjectPanel}
        query={MyProjects}
        variables={{ }}
        mapResult={data => ({ projects: data.myProjects })}
        childProps={{
            trackReference,
            versionReference,
            searchResultsPosition,
            onClose
        }}
    />;
}

SelectProjectPanelContainer.propTypes = {
    onClose: PropTypes.func.isRequired,
    trackReference: PropTypes.string,
    versionReference: PropTypes.string,
    searchResultsPosition: PropTypes.number,
    authenticated: PropTypes.bool.isRequired,
};

SelectProjectPanelContainer.defaultProps = {
    trackReference: null,
    versionReference: null,
    searchResultsPosition: null,
};

const ConnectedSelectProjectPanelContainer = connect(
    state => ({
        trackReference: state.project.trackReference,
        versionReference: state.project.versionReference,
        searchResultsPosition: state.project.searchResultsPosition,
        authenticated: state.authentication.id !== null,
    }),
    dispatch => ({
        onClose: () => dispatch(closeSelectProjectPanel()),
    })
)(SelectProjectPanelContainer);

export default ConnectedSelectProjectPanelContainer;
